module.exports = __webpack_public_path__ + "images/rich_heading/small_appliance/tablet/icon_f5da7a737d1c41ab29fa616fd7dae291.png";